import {I_ACCESS_TOKEN_PARAMS,_customFetch, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- CHARGES REPORT
// ---------------------------------

const ENDPOINT_CHARGES = '/charges';
const ENDPOINT_CHARGES_REPORT = '/charges/postpone';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from_date: string;
  from_date_end: string;
  to_date: string;
  to_date_end: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  collaborators: string;
  audited_customers: string;
  referentials: string;
}
/**
 * Requete le endpoint charges sans pagination
 * Récupère la liste des charges sans pagination
 * @param param0
 */
const getList = async ({
  accessToken,
  from_date,from_date_end,
  to_date,to_date_end,
  activity_types,
  directions_ops,hubs_ops,
  collaborators,
  audited_customers,
  referentials,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges without pagination - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramMode = `mode=all`;
  const paramFromDate = `from_date=${from_date}`;
  const paramFromDateEnd = `from_date_end=${from_date_end}`;
  const paramToDate = `to_date=${to_date}`;
  const paramToDateEnd = `to_date_end=${to_date_end}`;
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirectionsOps = directions_ops ? `directions_ops=${directions_ops}` : '';
  const paramHubsOps = hubs_ops ? `hubs_ops=${hubs_ops}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramsAll = [
    paramMode,
    paramFromDate,
    paramFromDateEnd,
    paramToDate,
    paramToDateEnd,
    paramActivityTypes,
    paramDirectionsOps,
    paramHubsOps,
    paramCollaborators,
    paramAuditedCustomers,
    paramReferentials,
  ].join('&');
  const URL = `${ENDPOINT_CHARGES}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};

interface I_CHARGES_REPORT_POST_PARAMS {
  accessToken: string;

  chargesIdSelected: number[];
  postpone_date: string;
  status_hourly_volume: 'INCREASE' | 'DECREASE' | 'KEEP';
  hourly_volume: number;
  keep_activities: boolean;
  keep_collaborators: boolean;
}
/**
 * Requete le endpoint charges report POST
 * Ajoute un charge
 * @param param0
 * @returns
 */
export const post = async ({
  accessToken,
  chargesIdSelected,
  postpone_date,
  status_hourly_volume,
  hourly_volume,
  keep_activities,
  keep_collaborators,
}:I_CHARGES_REPORT_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-report - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      id: chargesIdSelected,
      postpone_date,
      status_hourly_volume,
      hourly_volume,
      keep_activities,
      keep_collaborators,
      Keep_customer: true,
      mode_hourly_volume: 'percentage',
    })
  };

  // const sleep = (milliseconds:number) => {
  //   const start = new Date().getTime();
  //   for (let i = 0; i < 1e7; i++) {
  //     if ((new Date().getTime() - start) > milliseconds){
  //       break;
  //     }
  //   }
  // }
  // sleep(60000);

  const URL = ENDPOINT_CHARGES_REPORT + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};


interface I_GET_PROPS extends I_ACCESS_TOKEN_PARAMS {
  id_postpone: number;
}
/**
 * Requete le endpoint charges report GET
 * Récupère la liste des charges créées
 * @param param0
 */
const get = async ({
  accessToken,
  id_postpone,
}:I_GET_PROPS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-report - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_CHARGES_REPORT}/${id_postpone}/${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint charges report POST
 * Ajoute un charge
 * @param param0
 * @returns
 */
export const postCancel = async ({
  accessToken,
  id_postpone,
}:I_GET_PROPS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-report - postCancel...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    }
  };
  const URL = `${ENDPOINT_CHARGES_REPORT}-cancel/${id_postpone}/${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint charges report POST
 * Ajoute un charge
 * @param param0
 * @returns
 */
export const postValidate = async ({
  accessToken,
  id_postpone,
}:I_GET_PROPS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-report - postValidate...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    }
  };
  const URL = `${ENDPOINT_CHARGES_REPORT}-validate/${id_postpone}/${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const chargesEndpoints = {
  getList,
  post,
  get,
  postCancel,
  postValidate,
};

export default chargesEndpoints;
